import { minutesFromTime } from '@utilities/date'
import { CheckBoxItem, TableScheduled } from '@modules/admin/groups/styled'
import React from 'react'
import Dropdown from '@modules/admin/common/dropdown'
import { DROPDOWN_DEFAULT_VALUES_MAX, WEEK } from '@modules/admin/groups/components/specialitiesScheduleModal/constants'

export const isEmpty = (list) => {
  return Object.values(list).every((item) => !item)
}
export const correctSchedules = (list) => {
  let valueList = Object.values(list)
  let i = 1
  let fulfill = true
  while (i < valueList.length && fulfill) {
    if (minutesFromTime(valueList[i - 1]) < minutesFromTime(valueList[i])) i++
    else fulfill = false
  }
  return fulfill
}

export const createTable = ({ data, removeDay }) => {
  let rows = []
  data.forEach((item) => {
    let row
    let { day, start1, start2, finish1, finish2 } = item
    if (start1 && finish1) {
      row = (
        <div className="table-row">
          <div>{day}</div>
          <div>
            {`${start1}-${finish1}`}
            {start2 && ` / ${start2}-${finish2}`}
          </div>
          <div className="table-icons">
            <i className="fas fa-trash" onClick={() => removeDay(day)} />
          </div>
        </div>
      )
    }
    rows.push(row)
  })

  if (!rows.length) return
  return (
    <TableScheduled>
      <label>{'Franjas Horarias confirmadas'}</label>
      <div className="table-content">{rows}</div>
    </TableScheduled>
  )
}

export const createChecks = (addCheck) => {
  return WEEK.map((item) => {
    return (
      <CheckBoxItem>
        <input
          type="checkbox"
          value={item.value}
          onClick={(e) => {
            console.log('item', item)
            addCheck({ key: item.value, value: e?.currentTarget?.checked })
          }}
        ></input>
        {item.text}
      </CheckBoxItem>
    )
  })
}
export const createDropdowns = ({ splitted, addDrop }) => {
  const numberOfDropdowns = splitted ? 4 : 2
  var keys = Object.keys(DROPDOWN_DEFAULT_VALUES_MAX)
  const hours = getDrodownHours()
  let dropdownList = []
  for (var i = 0; i < numberOfDropdowns; i++) {
    dropdownList.push(<Dropdown list={hours} name={keys[i]} callback={addDrop} defaultText={'Elije un horario'} />)
  }
  return dropdownList
}

//obtiene un array que crea elementos de 0-23 horas con intervalos de 30 min
const getDrodownHours = () => {
  var foo = []
  for (var i = 0; i <= 47; i++) {
    var n = i % 2 === 0 ? i / 2 + ':00' : (i + 1) / 2 - 1 + ':30'
    if (n < 10)
      //zero-left padding
      n = '0' + n
    foo.push({ text: n, value: n })
  }
  return foo
}
